import {app} from "./app";
import {ApiRestangular} from './api-restangular.service';
// import {DeviceAdminActionsComponent} from "./device/device-admin-actions/device-admin-actions.component";
import {DeviceDetailsCommandsCtrl} from "./device/device-detail-command";
import {DeviceDetailsCtrl} from "./device/device-details.controller";
import {DevicesListingCtrl} from "./device/devices-listing.controller";
import {isManagedDeviceFilter} from "./device/is-managed-device.filter";
import {checkMultipleEmailsErrorFilter} from "./util/check-multiple-emails-error.filter";
import {skacDatetimeFilter} from "./util/skac-datetime.filter";
import {DevicePairingActionComponent} from "./device/device-pairing-action/device-pairing-action.component";
import {AdminCtrl} from "./admin/admin-controller";
// import { AdminSearchComponent } from './admin/components/search.component';

import {AuthenticationCtrl} from "./authentication/authentication-controller";
import {AppController} from "./app/app-controller";
import {DistributorSelectorCtrl} from "./distributor/distributor-selector-controller";
import {NoManagingOrgsCtrl} from "./distributor/distributors-controller";
import {DomainsCtrl} from "./domain/domains.controller";
import {DomainDetailsCtrl} from "./domain/domain-details.controller";
import {ProofOfPlayMultiLocationCtrl} from "./tenant/tenant-proofplay/multi-location.controller";
import {ProofOfPlayMultiDisplayCtrl} from "./tenant/tenant-proofplay/multi-display.controller";
import {ProofOfPlayMultiResourceCtrl} from "./tenant/tenant-proofplay/multi-resource.controller";
import {ProofOfPlayCtrl} from "./tenant/tenant-proofplay/tenant-proof-play";
import {ProofOfPlayReportsV2ListComponent} from "./tenant/proof-of-play-reports/proof-of-play-reports-v2-list/proof-of-play-reports-v2-list.component";
import {ProofOfPlayReportsV2Service} from "./tenant/proof-of-play-reports/proof-of-play-reports-v2.service";
import {ReportsCtrl} from "./reports/reports.controller";
// import {ManagingOrgDeviceReportComponent} from "./reports/managing-org-device-report/managing-org-device-report.component";
import {ReportsListComponent} from "./reports/reports-list/reports-list.component";
import {SkacValidateEmailDirective} from "./util/skac-validate-email.directive";
import {TenantLogsCtrl} from "./tenant/tenant-logs.controller";
import {TenantOverlaysCtrl} from "./tenant/tenant-overlays.controller";
import {TenantAddCtrl} from "./tenant/tenant-add.controller";
import {TenantDetailsCtrl} from "./tenant/tenant-details.controller";
import {TenantLocationCtrl} from "./tenant/tenant-location.controller";
import {TenantLocationsCtrl} from "./tenant/tenant-locations.controller";
import {TenantManagedDevicesCtrl} from "./tenant/tenant-managed-devices.controller";
import {TenantUnmanagedDevicesCtrl} from "./tenant/tenant-unmanaged-devices.controller";
import {TenantsCtrl} from "./tenant/tenants.controller";
import {WelcomeCtrl} from "./welcome/welcome-controller";
import {routes} from "./app-routes";
import {appRun} from "./app-run";
import {breadcrumbProvider, toastrConfig} from "./app-config";
import {RedirectCtrl} from "./redirect/redirect.controller";
import ImageService from "./services/image.service";
import AdminService from "./services/admin.service";
import AuthorizationService from "./services/authorization.service";
import CommandsService from "./services/commands.service";
import BeaconsService from "./services/beacons.service";
import DateManipulationService from "./services/datemanipulation.service";
import EmailService from "./services/email.service";
import DevicesService from "./services/devices.service";
import DistributorsService from "./services/distributors.service";
import DomainsService from "./services/domains.service";
import IntegrationEvents from "./services/integration-events.service";
import LocationsService from "./services/locations.service";
import ProgressBarService from "./services/progressbar.service";
import ProofPlayService from "./services/proofplay.service";
import ReportingService from "./services/reporting.service";
import SessionsService from "./services/sessions.service";
import StorageService from "./services/storage.service";
import TenantsService from "./services/tenants.service";
import TimezonesService from "./services/timezones.service";
import ToastsService from "./services/toasts.service";
import UrlService from "./services/url.service";
import VersionsService from "./services/versions.service";
import UnifiedLoginService from "./services/unifiedLogin.service";
import AuthV2Service from './services/auth.v2.service';
import * as firebase from "firebase/app";
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'

firebase.initializeApp(window.SK_ENV.firebaseConfig);

app
// Services
  .factory('ApiRestangular', ApiRestangular)
  .service("StorageService", StorageService)
  .service("AdminService", AdminService)
  .service("AuthorizationService", AuthorizationService)
  .service("CommandsService", CommandsService)
  .service("DateManipulationService", DateManipulationService)
  .service("EmailService", EmailService)
  .service("DevicesService", DevicesService)
  .service("DistributorsService", DistributorsService)
  .service("DomainsService", DomainsService)
  .service("IntegrationEvents", IntegrationEvents)
  .service("LocationsService", LocationsService)
  .service("ProgressBarService", ProgressBarService)
  .service("ProofPlayService", ProofPlayService)
  .service("ReportingService", ReportingService)
  .service("SessionsService", SessionsService)
  .service("TenantsService", TenantsService)
  .service("TimezonesService", TimezonesService)
  .service("ToastsService", ToastsService)
  .service("VersionsService", VersionsService)
  .service("ImageService", ImageService)
  .service("BeaconsService", BeaconsService)
  .service("UrlService", UrlService)
  .service("UnifiedLoginService", UnifiedLoginService)
  .service("AuthV2Service", AuthV2Service)
  // Device
  .controller("DeviceDetailsCommandsCtrl", DeviceDetailsCommandsCtrl)
  .controller("DeviceDetailsCtrl", DeviceDetailsCtrl)
  .controller("DevicesListingCtrl", DevicesListingCtrl)
  .component("devicePairingAction", DevicePairingActionComponent)
  .filter("isManagedDevice", isManagedDeviceFilter)
  // .component("deviceAdminActions", DeviceAdminActionsComponent)
  // Admin
  .controller("AdminCtrl", AdminCtrl)
  // .component('adminSearch', AdminSearchComponent)
  // Authentication
  .controller("AuthenticationCtrl", AuthenticationCtrl)
  // App
  .controller("AppController", AppController)
  // Distributors
  .controller("DistributorSelectorCtrl", DistributorSelectorCtrl)
  .controller("NoManagingOrgsCtrl", NoManagingOrgsCtrl)
  // Domains
  .controller("DomainsCtrl", DomainsCtrl)
  .controller("DomainDetailsCtrl", DomainDetailsCtrl)
  // ProofPlay
  .controller("ProofOfPlayMultiLocationCtrl", ProofOfPlayMultiLocationCtrl)
  .controller("ProofOfPlayMultiDisplayCtrl", ProofOfPlayMultiDisplayCtrl)
  .controller("ProofOfPlayMultiResourceCtrl", ProofOfPlayMultiResourceCtrl)
  .controller("ProofOfPlayCtrl", ProofOfPlayCtrl)
  // ProofOfPlayReports
  .factory('ProofOfPlayReportsV2Service', ProofOfPlayReportsV2Service)
  .component('proofOfPlayReportsV2List', ProofOfPlayReportsV2ListComponent)
  //Reports
  .controller("ReportsCtrl", ReportsCtrl)
  // .component("managingOrgDeviceReport", ManagingOrgDeviceReportComponent)
  .component("reportsList", ReportsListComponent)
  // Tenants
  .controller("TenantLogsCtrl", TenantLogsCtrl)
  .controller("TenantOverlaysCtrl", TenantOverlaysCtrl)
  .controller("TenantAddCtrl", TenantAddCtrl)
  .controller("TenantDetailsCtrl", TenantDetailsCtrl)
  .controller("TenantLocationCtrl", TenantLocationCtrl)
  .controller("TenantLocationsCtrl", TenantLocationsCtrl)
  .controller("TenantManagedDevicesCtrl", TenantManagedDevicesCtrl)
  .controller("TenantUnmanagedDevicesCtrl", TenantUnmanagedDevicesCtrl)
  .controller("TenantsCtrl", TenantsCtrl)
  // Util
  .directive("skacValidateEmail", SkacValidateEmailDirective)
  .filter("checkMultipleEmailsError", checkMultipleEmailsErrorFilter)
  .filter("skacDatetime", skacDatetimeFilter)
  // Welcome
  .controller("WelcomeCtrl", WelcomeCtrl)
  // Redirect
  .controller("RedirectCtrl", RedirectCtrl)
  // appRun Block
  .run(appRun)
  // Config
  .config(routes)
  .config(toastrConfig)
  .config(breadcrumbProvider)

app.config(function (RestangularProvider) {

  const baseUrl = `${process.env.__backendUrl__}/internal/v1`;
  
  // const baseUrl = `http://localhost:8080/internal/v1`;
  console.log(baseUrl)
  RestangularProvider.setBaseUrl(baseUrl);

  // I believe { id: 'key' } is fallback/leftover from Datastore migration
  // 'id' is copied to 'key' by the base serializer
  // See:
  // - serializer_schema/base_serializer.py:BaseSchema.as_dict
  // - skykit-adminconsole/json_helper.py:convert_dictionary_key_snake_case_to_camel_case
  RestangularProvider.setRestangularFields({
    id: 'key'
  });

  RestangularProvider.setErrorInterceptor(function (response) {
    if (response.status === 401) {
      window.location.href = '/#/sign_out';
    }
    return response;
  })

});

app.service('RequestInterceptor', function (StorageService, $location) {
  "ngInject";
  let interceptor = {
    request(config) {
      config.headers = {
        // 'Content-Type': 'application/json',
        // 'Accept': 'application/json',
        'oAuth': StorageService.get('oAuth'),
        "Access-Control-Allow-Origin": "*",
        'X-Provisioning-User': StorageService.get('userKey'),
        'X-Provisioning-User-Identifier': StorageService.get('userEmail'),
        'X-Provisioning-Distributor': StorageService.get('currentDistributorKey'),
        'X-Provisioning-ManagingOrg': StorageService.get('currentDistributorKey')
      };
      const idToken = StorageService.get('idToken');  // TODO: use SessionsService instead if possible.
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
      }
      return config;
    }
  };
  return interceptor;
});


app.config($httpProvider => $httpProvider.interceptors.push('RequestInterceptor'));
